// Helpers for the AddContactForm popover — extracted so the payload-building
// transformations stay unit-testable independent of the React component.

export interface ContactFormPayload {
  contactName: string;
  organization?: string;
  phone1?: string;
  phone2?: string;
  email?: string;
  notes?: string;
  contactType: 'Service';
  isActive: true;
  [key: string]: unknown;
}

export interface ContactFormState {
  contactName: string;
  organization: string;
  phone1: string;
  phone2: string;
  email: string;
  notes: string;
}

export const emptyContactForm: ContactFormState = {
  contactName: '',
  organization: '',
  phone1: '',
  phone2: '',
  email: '',
  notes: '',
};

const OPTIONAL_FIELDS: Array<keyof ContactFormState> = [
  'organization',
  'phone1',
  'phone2',
  'email',
  'notes',
];

// Build the service-attribute payload sent to /serviceAttributesBulkCreateOrUpdate.
// Trims all values, drops empty optional fields, and forces contactType +
// isActive so the BFF treats the row as a new active service contact.
export const buildContactPayload = (state: ContactFormState): ContactFormPayload => {
  const payload: ContactFormPayload = {
    contactName: state.contactName.trim(),
    contactType: 'Service',
    isActive: true,
  };
  OPTIONAL_FIELDS.forEach((key) => {
    const value = state[key].trim();
    if (value) payload[key] = value;
  });
  return payload;
};
